import React from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

type Avatar37Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar37 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar37Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar37" clipPath="url(#clip0_2286_5400)">
        <Path
          id="background"
          d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
          fill={c.background}
        />
        <Path
          id="skin"
          d="M214.008 136.407c0-48.596.159-91.984-41.516-91.984-75.244 0-81.488 30.55-81.488 79.138 0 1.139.032 2.286.088 3.432-.789.104-1.609.295-2.469.59-6.124 2.062-7.231 13.849-2.477 26.329 4.635 12.169 13.133 20.491 19.233 18.986.382.661.765 1.322 1.155 1.975.43 4.245 2.174 22.578 1.195 30.279-1.115 8.728-7.391 21.192-7.391 21.192s44.312 37.63 75.992 34.827c13.276.039 11.93-12.376 11.93-12.376s-1.72-10.266-.493-16.446c.716-3.576 25.468-51.479 25.365-66.388-.04-5.535.876-13.507.876-29.554Z"
          fill={c.skin}
        />
        <Path
          id="Vector"
          d="M126.293 127.973s11.826-2.118 21.869-2.118c7.127 0 16.055 1.648 19.376 1.983.82.079 1.625-.247 2.126-.86l1.856-2.254c1.012-1.235.406-3.042-1.179-3.504-5.025-1.474-14.836-4.811-21.59-4.293-9.668.741-16.549 1.091-22.466 11.046h.008Z"
          fill="#000"
        />
        <Path
          id="Vector_2"
          d="M197.985 184.461s-9.892 1.705-20.914 1.163c-12.201-.597-25.66-3.4-25.66-2.15 0 2.381 18.771 9.796 25.254 9.796 8.505 0 21.694-7.805 21.32-8.816v.007Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_3"
          d="M183.243 199.665h-13.164c-.892 0-1.434.964-.956 1.696.82 1.259 2.74 2.764 7.239 2.764 4.5 0 6.603-1.41 7.733-2.644.645-.701.112-1.816-.86-1.816h.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_4"
          d="M166.28 140.309c-2.739-3.767-5.917-6.068-9.198-7.406-2.007-.813-4.046-1.267-6.045-1.466-6.283-.637-12.153 1.187-15.187 1.991-.964.255-1.227 1.569-.47 2.294l1.441 1.354c.335.318.797.438 1.211.302 1.378-.446 5.177-.963 9.143-1.314a5.876 5.876 0 0 0 .095 2.262c.757 3.154 3.903 5.105 7.032 4.356 2.764-.661 4.572-3.217 4.428-5.989 3.059 1.227 5.934 2.931 7.216 3.99.231.192.509-.135.334-.382v.008Z"
          fill="#000"
        />
        <Path
          id="Vector_5"
          d="M191.996 167.355c.095-4.961-4.412-13.786-4.532-25.293-.088-8.848 4.747-19.409 2.079-20.237-2.668-.828-5.352 9.039-5.503 20.356-.096 7.096 5.535 25.166 2.914 26.432-2.62 1.267-18.994-1.991-19.679.725-.685 2.716 2.748 3.249 13.929 4.054 8.689-.351 10.696-1.067 10.8-6.029l-.008-.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_6"
          d="M202.516 129.55a18.679 18.679 0 0 0-5.415 1.617c-2.955 1.409-5.838 3.783-8.378 7.597-.168.255.071.566.286.367 1.163-1.091 3.767-2.859 6.523-4.157-.199 2.747 1.338 5.24 3.783 5.829 2.755.661 5.606-1.362 6.363-4.515a6.554 6.554 0 0 0 .143-2.246c3.369 0 7.948.82 8.187.701v-4.158c-2.867-.764-7.04-1.672-11.492-1.035Z"
          fill="#000"
        />
        <Path
          id="Vector_7"
          d="M187.082 125.058c-.104.868.693 1.593 1.585 1.45 3.599-.582 10.074-1.585 13.969-1.474 4.603.128 11.277.869 11.277.869s.868-6.682-.733-7.781c-1.601-1.099-7.208-1.163-11.548-1.163s-7.072.908-9.413 1.872c-3.64 1.513-4.89 4.149-5.137 6.227Z"
          fill="#000"
        />
        <Path
          id="Vector_8"
          d="M188.26 248.795s1.338 12.416-11.93 12.376c-31.68 2.804-75.992-34.826-75.992-34.826l-57.357 31.322c27.588 28.368 66.157 46 108.852 46 33.266 0 64.031-10.704 89.045-28.853l-52.618-26.019Z"
          fill="#000"
        />
        <Path
          id="Vector_9"
          d="M188.26 248.795s1.338 12.416-11.93 12.376c-31.68 2.804-75.992-34.826-75.992-34.826l-57.357 31.322c27.588 28.368 66.157 46 108.852 46 33.266 0 64.031-10.704 89.045-28.853l-52.618-26.019Z"
          fill="#000"
        />
        <Path
          id="hair"
          d="M226.376 77.96c-.661-8.753-6.507-11.15-9.533-13.412-3.026-2.27-1.011-7.056-4.03-11.332-3.018-4.277-10.074-2.772-14.359-5.79-4.284-3.019-8.059-11.333-16.119-12.6-8.059-1.266-18.643 3.776-23.43 3.776-4.786 0-14.104-7.056-25.19-5.288-11.086 1.76-13.857 11.332-19.145 15.115-5.288 3.783-11.333 1.513-15.872 5.288-4.532 3.775-5.543 11.333-5.543 15.116 0 3.783-7.558 4.786-10.075 8.816-2.516 4.03-.255 10.576 2.015 20.906 2.27 10.329 1.513 22.163 1.011 28.216-.055.653 0 1.449.128 2.357.685-.701 1.481-1.226 2.389-1.537 10.178-3.432 14.94 6.379 19.695 18.851.311.812.597 1.625.852 2.437l2.636-.446c0-30.9 11.659-34.771 12.034-40.059.47-6.57-6.873-20.85 9.262-27.611 16.135-6.761 37.972 6.77 48.54 6.276 10.569-.494 9.74-5.782 19.48-4.787 9.74.988 12.878 25.421 12.878 25.421s3.799-5.28 5.941-8.585c2.142-3.305 7.096-12.384 6.435-21.128Z"
          fill={c.hair}
        />
        <Path
          id="Vector_10"
          d="M191.398 223.963c-3.998.295-10.018.518-18.134.828-33.934 1.291-54.633-34.627-54.633-34.627s12.185 51.599 67.694 66.571c2.405-3.552 1.935-7.94 1.935-7.94s-1.72-10.266-.493-16.446c.159-.812 1.561-3.91 3.631-8.386Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_2286_5400">
          <Rect width={303.667} height={303.667} fill="#fff" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
